/* This file is auto-generated. Do not edit directly. */
/* eslint-disable */
export enum CommitResultStatus {
  ValidationErrors = 'ValidationErrors',
  PendingPayment = 'PendingPayment',
  ReservationCommitted = 'ReservationCommitted',
  CommitInProgress = 'CommitInProgress'
}

